import styled from 'styled-components';
export const InfoGroup = styled.span`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0px;
  margin-bottom: 2px;
`;
